import React from 'react';

const steps = [
  'Automatic water sample filtration and bacteria enrichment',
  'Reagent addition and incubation at 38±1°C',
  'Observation of light absorption and fluorescence emission',
];

export default function WorkingProcess() {
  return (
    <section id="process" className="scroll-mt-28 bg-gray-50 px-6 py-16 sm:py-20" data-aos="fade-right">
      <div className="max-w-[1600px] mx-auto">
        <h2 className="text-3xl font-bold text-center text-teal-700 mb-10">Working Process</h2>

        <div className="max-w-2xl mx-auto space-y-6">
          {steps.map((step, i) => (
            <div key={step} className="flex items-start gap-4">
              <div className="shrink-0 w-9 h-9 rounded-full bg-teal-600 text-white flex items-center justify-center font-semibold shadow-md">
                {i + 1}
              </div>
              <p className="text-gray-700 leading-relaxed pt-1.5">{step}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
